import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useEmployeeFiles = (id) => useQuery({ queryKey: [`${id}-files`], queryFn: async () => {
    const callback = await API.get(`/employees/${id}/files`)
    return callback?.data
}})

export default useEmployeeFiles